import { AxiosResponse } from "axios"
import $api from "../../../axios"
import {
  IGetSbPlacementBody,
  IGetSbPlacementResponse,
  IUpdateSbBidAdjustmentsParams,
} from "../types/sbPlacementApi.types"

class SbPlacementApi {
  url: string

  constructor() {
    this.url = "/SB/placement"
  }

  async getPlacementData(
    data: IGetSbPlacementBody
  ): Promise<AxiosResponse<IGetSbPlacementResponse>> {
    return $api.post(`${this.url}/getPlacementData`, data)
  }

  async updateBidAdjustments(data: IUpdateSbBidAdjustmentsParams): Promise<AxiosResponse<any>> {
    return $api.post(`${this.url}/updateBidAdjustments`, data)
  }
}

export default new SbPlacementApi()
